import React from 'react';
import { ArrowRightIcon, StarIcon, CheckCircleIcon, ShieldIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/rZKRMiYtZpATgnJMp1SqhQ/ChatGPT_Image_27_mar_2026,_07_05_39_p.m..png';
export function HeroSection() {
  const handleScroll = () => {
    document.getElementById('producto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section style={{
    backgroundColor: '#F5EDE4'
  }} data-id="element-117">
      {/* MOBILE LAYOUT: image on top, text below */}
      <div className="block md:hidden" data-id="element-118">
        <div className="relative w-full" data-id="element-119">
          <img src={HERO_IMG} alt="Emely con Cinnamon Rolls XL y libro Estilo New York" width={900} height={1200} className="w-full object-cover"
        // @ts-ignore
        fetchpriority="high" decoding="async" style={{
          maxHeight: '70vh',
          display: 'block'
        }} data-id="element-120" />
          <div className="absolute bottom-0 left-0 right-0 pointer-events-none" style={{
          height: '40%',
          background: 'linear-gradient(to top, #F5EDE4, transparent)'
        }} data-id="element-121" />
        </div>

        <div className="max-w-4xl mx-auto px-4 pt-6 pb-14 text-center hero-fade-in" data-id="element-122">
          <span className="inline-block text-xs font-bold tracking-[0.25em] uppercase mb-4" style={{
          color: '#e76f51'
        }} data-id="element-123">
            EDICIÓN COLECCIONABLE
          </span>

          <h1 className="mb-4 leading-[1.15]" data-id="element-124">
            <span className="block text-2xl italic mb-3" style={{
            color: '#5a5248',
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-125">
              "El cinnamon roll siempre ha sido delicioso…
            </span>
            <span className="block text-2xl font-bold" style={{
            color: '#1A1614'
          }} data-id="element-126">
              pero hoy puede ser mucho más que un postre."
            </span>
          </h1>

          <p className="text-base mb-6" style={{
          color: '#5a5248'
        }} data-id="element-127">
            Descubre cómo convertir un clásico al formato XL estilo New York
            viral.
          </p>

          <div className="flex flex-col items-center gap-2 mb-6" data-id="element-128">
            <div className="flex items-center gap-2" data-id="element-129">
              <div className="flex items-center gap-0.5" data-id="element-130">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-131" />)}
              </div>
              <span className="text-sm font-bold" style={{
              color: '#1A1614'
            }} data-id="element-132">
                Más de +998 Alumnos Felices
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-133">
              <CheckCircleIcon className="w-4 h-4" style={{
              color: '#07c86e'
            }} data-id="element-134" />
              <span className="text-sm font-medium" style={{
              color: '#07c86e'
            }} data-id="element-135">
                Verificado
              </span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-136">
            <button onClick={handleScroll} className="inline-flex items-center gap-3 font-bold text-base py-4 px-8 rounded-full transition-all duration-300 w-full sm:w-auto justify-center" style={{
            backgroundColor: '#e76f51',
            color: '#ffffff',
            boxShadow: '0 4px 24px rgba(231,111,81,0.3)'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#f08565';
            e.currentTarget.style.transform = 'scale(1.02)';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = '#e76f51';
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-137">
              Quiero descubrir los Cinnamon Rolls XL
              <ArrowRightIcon className="w-5 h-5" data-id="element-138" />
            </button>
            <span className="text-xs flex items-center gap-2" style={{
            color: '#5a5248'
          }} data-id="element-139">
              Garantía 30 días · Descarga inmediata
            </span>
          </div>
        </div>
      </div>

      {/* DESKTOP/TABLET LAYOUT: text left, image right */}
      <div className="hidden md:flex items-center max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24 gap-10 lg:gap-16" data-id="element-140">
        <div className="flex-1 min-w-0 hero-fade-in" data-id="element-141">
          <span className="inline-block text-xs font-bold tracking-[0.25em] uppercase mb-6" style={{
          color: '#e76f51'
        }} data-id="element-142">
            EDICIÓN COLECCIONABLE
          </span>

          <h1 className="mb-6 leading-[1.15]" data-id="element-143">
            <span className="block text-3xl lg:text-4xl italic mb-4" style={{
            color: '#5a5248',
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-144">
              "El cinnamon roll siempre ha sido delicioso…
            </span>
            <span className="block text-3xl lg:text-5xl font-bold" style={{
            color: '#1A1614'
          }} data-id="element-145">
              pero hoy puede ser mucho más que un postre."
            </span>
          </h1>

          <p className="text-xl lg:text-2xl mb-8" style={{
          color: '#5a5248'
        }} data-id="element-146">
            Descubre cómo convertir un clásico al formato XL estilo New York
            viral.
          </p>

          <div className="flex flex-col items-start gap-2 mb-8" data-id="element-147">
            <div className="flex items-center gap-2" data-id="element-148">
              <div className="flex items-center gap-0.5" data-id="element-149">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-150" />)}
              </div>
              <span className="text-sm font-bold" style={{
              color: '#1A1614'
            }} data-id="element-151">
                Más de +998 Alumnos Felices
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-152">
              <CheckCircleIcon className="w-4 h-4" style={{
              color: '#07c86e'
            }} data-id="element-153" />
              <span className="text-sm font-medium" style={{
              color: '#07c86e'
            }} data-id="element-154">
                Verificado
              </span>
            </div>
          </div>

          <div className="flex flex-col gap-3 items-center justify-center" data-id="element-155">
            <button onClick={handleScroll} className="inline-flex items-center gap-3 font-bold text-lg py-5 px-10 rounded-full transition-all duration-300" style={{
            backgroundColor: '#e76f51',
            color: '#ffffff',
            boxShadow: '0 4px 24px rgba(231,111,81,0.3)'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#f08565';
            e.currentTarget.style.transform = 'scale(1.02)';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = '#e76f51';
            e.currentTarget.style.transform = 'scale(1)';
          }} data-id="element-156">
              Quiero descubrir los Cinnamon Rolls XL
              <ArrowRightIcon className="w-5 h-5" data-id="element-157" />
            </button>
            <span className="text-sm flex gap-2 items-center justify-center" style={{
            color: '#5a5248'
          }} data-id="element-158">
              <ShieldIcon className="w-4 h-4" data-id="element-159" /> Garantía 7 días · Descarga
              inmediata
            </span>
          </div>
        </div>

        <div className="flex-1 min-w-0 relative hero-fade-in-right" data-id="element-160">
          <img src={HERO_IMG} alt="Emely con Cinnamon Rolls XL y libro Estilo New York" width={900} height={1200} className="w-full h-auto rounded-3xl shadow-2xl object-cover"
        // @ts-ignore
        fetchpriority="high" decoding="async" style={{
          maxHeight: '75vh'
        }} data-id="element-161" />
        </div>
      </div>
    </section>;
}